export enum ApiResultMessageType {
    Error = 'Error',
    Information = 'Information',
    Inquiry = 'Inquiry',
    Other = 'Other',
    Success = 'Success',
    Warning = 'Warning'
}
